export const TYPE_PREFIX = 'table/'

export const QUERY_REQUEST = '/PREFIX_QUERY_REQUEST'
export const QUERY_SUCCESS = '/TABLE_QUERY_SUCCESS'
export const QUERY_ERROR = '/TABLE_QUERY_ERROR'
export const CHANGE_FILTER = '/CHANGE_FILTER'
export const TOGGLE_SORT = '/TOGGLE_SORT'
export const TOGGLE_MULTI_SORT = '/MULTI_TOGGLE_SORT'
export const GOTO_PAGE = '/GOTO_PAGE'
export const SET_HIDDEN_COLUMNS = '/SET_HIDDEN_COLUMNS'





// WEBPACK FOOTER //
// ./src/modules/table/state/type.js